import { ListItem, Skeleton, Stack } from '@mui/material';

export const NewsCardSkeleton = () => {
  return (
    <ListItem
      sx={{
        width: '100%',
        p: 2,
      }}
    >
      <Stack width="100%" spacing={0.5}>
        <Skeleton variant="rectangular" sx={{ m: 0, p: 0 }} height={180} />
        <Skeleton height={22} width="40%" />
        <Skeleton height={14} />
        <Skeleton height={14} width="60%" />
      </Stack>
    </ListItem>
  );
};
